/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import uniqueId from 'lodash/uniqueId';
import { Alert } from 'sarsaparilla';

type Error = string | undefined | null;

export interface ErrorNotificationProps {
    errorHeader?: string;
    errors?: Error[];
    className?: string;
    innerRef?: React.RefObject<any>;
}

export function ErrorNotification({
    errorHeader = 'Errors:',
    className = 'mb-4',
    errors = [],
    innerRef,
}: ErrorNotificationProps) {
    return (
        <div tabIndex={-1} className="rec-error-notification" ref={innerRef}>
            {errors?.length ? (
                <Alert
                    className={className}
                    type="error"
                    heading={errorHeader}
                    key={uniqueId()} // adding new key to Notification to force update so it reads out everything on voiceover
                    hasAriaLive
                >
                    <ul>
                        {errors
                            .filter((err) => err)
                            .map((err, index) => (
                                <li key={index}>
                                    <div className="permit-validation">{err}</div>
                                </li>
                            ))}
                    </ul>
                </Alert>
            ) : null}
        </div>
    );
}
